import { getSessionStorage } from '@core/storage'

import type { IReturn } from './useStorage'
import { useStorage } from './useStorage'

/**
 * Simple hook to read and write to session storage. Does not synchronize or listen
 * to changes in other tabs.
 */
export function useSessionStorage<T>(key: string, initial: T): IReturn<T> {
  const storage = getSessionStorage()
  return useStorage(key, initial, {
    storage,
  })
}
